// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FloatingLabelInput.css */
.floating-label-input {
    position: relative;
    margin-bottom: 20px;
    width: 100%;
  }
  
  .floating-label-input label {
    position: absolute;
    top: 50%;
    left: 10px;
    transform: translateY(-50%);
    transition: all 0.3s ease;
    background-color: white;
    padding: 0 5px;
    pointer-events: none;
    font-size: 14px;
    opacity: 0.8;
    z-index: 1;
  }
  
  .floating-label-input.focused label,
  .floating-label-input input:focus + label,
  .floating-label-input input:not(:placeholder-shown) + label,
  .floating-label-input .ant-select-focused + label,
.floating-label-input .ant-select:not(.ant-select-customize-input).ant-select-open + label,
.floating-label-input .ant-select:not(.ant-select-customize-input).ant-select-focused + label {
    top: 0;
    left: 10px;
    font-size: 13px;
    font-weight: 500;
    opacity: 1;
    z-index: 11;
  }
  
  .floating-label-input input,
  .floating-label-input .ant-select {
    width: 100%;
    padding: 10px 14px;
    outline: none;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    transition: border-color 0.3s;
  }
  
  .floating-label-input input:focus,
  .floating-label-input .ant-select-focused {
    border-color: #40a9ff;
  }

  button.ant-btn {
    background: #6612f0;
    border-radius: 5px;
    font-size: 14px;
}
  
button.ant-btn:hover {
  background: #6612f0 !important;
}

.ant-btn-primary:disabled {
  background: #6612f07a;
  color: #eee;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/FloatingLabelInput.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,2BAA2B;IAC3B,yBAAyB;IACzB,uBAAuB;IACvB,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,UAAU;EACZ;;EAEA;;;;;;IAME,MAAM;IACN,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,WAAW;EACb;;EAEA;;IAEE,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb","sourcesContent":["/* FloatingLabelInput.css */\r\n.floating-label-input {\r\n    position: relative;\r\n    margin-bottom: 20px;\r\n    width: 100%;\r\n  }\r\n  \r\n  .floating-label-input label {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 10px;\r\n    transform: translateY(-50%);\r\n    transition: all 0.3s ease;\r\n    background-color: white;\r\n    padding: 0 5px;\r\n    pointer-events: none;\r\n    font-size: 14px;\r\n    opacity: 0.8;\r\n    z-index: 1;\r\n  }\r\n  \r\n  .floating-label-input.focused label,\r\n  .floating-label-input input:focus + label,\r\n  .floating-label-input input:not(:placeholder-shown) + label,\r\n  .floating-label-input .ant-select-focused + label,\r\n.floating-label-input .ant-select:not(.ant-select-customize-input).ant-select-open + label,\r\n.floating-label-input .ant-select:not(.ant-select-customize-input).ant-select-focused + label {\r\n    top: 0;\r\n    left: 10px;\r\n    font-size: 13px;\r\n    font-weight: 500;\r\n    opacity: 1;\r\n    z-index: 11;\r\n  }\r\n  \r\n  .floating-label-input input,\r\n  .floating-label-input .ant-select {\r\n    width: 100%;\r\n    padding: 10px 14px;\r\n    outline: none;\r\n    border: 1px solid #d9d9d9;\r\n    border-radius: 4px;\r\n    transition: border-color 0.3s;\r\n  }\r\n  \r\n  .floating-label-input input:focus,\r\n  .floating-label-input .ant-select-focused {\r\n    border-color: #40a9ff;\r\n  }\r\n\r\n  button.ant-btn {\r\n    background: #6612f0;\r\n    border-radius: 5px;\r\n    font-size: 14px;\r\n}\r\n  \r\nbutton.ant-btn:hover {\r\n  background: #6612f0 !important;\r\n}\r\n\r\n.ant-btn-primary:disabled {\r\n  background: #6612f07a;\r\n  color: #eee;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
